module.exports = __webpack_public_path__ + "img/68f01a004889bffbd65019ef28d021b5.545af86d.jpg";